<template>
  <div class="demo-spin-article">
    <Row type="flex" justify="space-between" style="padding-top: 5px" class="mb-30">
      <Col>
        <Button type="info">Скачать отчет</Button>
      </Col>
      <Col>
        <Select
          style="width: 200px"
          placeholder="Список отчетов"
        >
          <Option
            value="period_report"
          >Отчет 1
          </Option>
          <Option
            value="period_ticket_report"
          >Отчет 2
          </Option>
        </Select>
      </Col>
      <Col>
        <Select
          style="width: 200px"
          placeholder="Список признаков"
        >
          <Option
            value="period_report"
          >Признак 1
          </Option>
          <Option
            value="period_ticket_report"
          >Признак 2
          </Option>
        </Select>
      </Col>
      <Col>
        <Select
          style="width: 200px"
          placeholder="Список магазинов"
        >
          <Option
            v-for="item in store"
            :value="item.id"
            :key="item.id"
          >
            {{ item.name }}

          </Option
          >
        </Select>
      </Col>
      <Col>
        <DatePicker
          @on-change="changeFilterOrderDate"
          @on-clear="clearFilterOrderDate"
          format="dd.MM.yyyy"
          type="date"
          split-panels
          placeholder="Дата документа"
          style="width: 200px"
        ></DatePicker>
      </Col>
    </Row>

    <Row :gutter="20" type="flex" class="mb-30">
      <Col span="4">
        <div class="card-container box box-1">
          <h3>Лучшее время</h3>

        </div>
      </Col>
      <Col span="4">
        <div class="card-container box box-2">
          <h3>Лучший день недели</h3>
        </div>
      </Col>
      <Col span="4">
        <div class="card-container box box-3">
          <h3>Лучший день месяца</h3>
        </div>
      </Col>
      <Col span="4">
        <div class="card-container box box-4">
          <h3>Лучший месяц</h3>
          <h2></h2>
        </div>
      </Col>
      <Col span="4">
        <div class="card-container">
          <h3>Лучший сезон</h3>
        </div>
      </Col>
      <Col span="4">
        <div class="card-container">
          <h3>Лучший год</h3>
        </div>
      </Col>
    </Row>


    <!--    <Row>-->
    <!--      <Menu-->
    <!--        mode="horizontal"-->
    <!--        :active-name="defaultFilter"-->
    <!--        @on-select="selectFilter"-->
    <!--        style="line-height: 0; height: 30px"-->
    <!--      >-->
    <!--        <MenuItem name="year" class="menu-item">-->
    <!--          Год-->
    <!--        </MenuItem>-->
    <!--        <MenuItem name="month" class="menu-item">-->
    <!--          Месяц-->
    <!--        </MenuItem>-->
    <!--        <MenuItem name="week" class="menu-item">-->
    <!--          Неделя-->
    <!--        </MenuItem>-->
    <!--        <MenuItem name="day" class="menu-item">-->
    <!--          День-->
    <!--        </MenuItem>-->
    <!--      </Menu>-->
    <!--    </Row>-->




  </div>
</template>

<script>

    import {base_url} from "../../http.js";
    import { BaseFormData } from "../../base/base_form_v2.js";

    import topProducts from "@/apps/report/topProducts.vue";
    import revenueBar from "@/apps/home/revenueBar";
    import paymentType2 from "@/apps/home/paymentType2";



    let base = BaseFormData();

    base.components = {
        topProducts,
        revenueBar,
        paymentType2
    };

    base.data = function () {
        return {
            loading: true,

            store: [],

            totalAverageOrder: '',
            defaultFilter: "month"


        };
    };

    base.methods.getStore = function() {
        const url = base_url + "/stores/";
        this.$http
            .get(url)
            .then(result => {
                this.store = result.data.results;
            })
    };


    base.mounted = function() {
        this.getStore();
    };






    export default base;

</script>

<style scoped>
  .card-container {
    text-align: center;
    padding: 15px 30px;
  }

  .card-container.box h2, .card-container.box h3{
    color: #ffffff
  }
  .card-container.box-1 {
    background-color: #C450C4;
  }
  .card-container.box-2 {
    background-color: #25D77E;
  }
  .card-container.box-3 {
    background-color: #5087DE;
  }
  .card-container.box-4 {
    background-color: #FFB12C;
  }

  .card-container h3 {
    margin-bottom: 5px;
    opacity: 0.7;
  }
  .card-container h2 {
    font-size: 28px;
  }

</style>



// WEBPACK FOOTER //
// src/apps/report/seasonality.vue